<template>
  <b-container fluid>
    <div>
      <div class="d-flex flex-column">
        <HeaderSearch from="Resultats"></HeaderSearch>
        <!-- Table -->
        <b-col v-if="!radioSynthese">
          <div>
            <b-col md="12">
              <b-pagination
                v-if="disablePagination === false"
                :total-rows="totalItems"
                :per-page="perPage"
                v-model="currentPage"
              ></b-pagination>
            </b-col>
            <b-table
              striped
              hover
              responsive
              v-on:row-clicked="rowSelected"
              :items="results"
              :fields="fields"
              :busy="isBusy"
              outlined
              :class="`font_size_0_7 ${tri !== 'resultatsRadio' ? 'tr-click' : ''}`"
              show-empty
              emptyText="Il n'y a aucun résultat"
            >
              <div slot="table-busy" class="text-center">
                <b-spinner
                  class="align- middle color_green_labco"
                  type="grow"
                />
              </div>
            </b-table>
            <b-row
              v-if="
                disablePagination === false &&
                results != null &&
                totalItems > perPage
              "
            >
              <b-col md="12">
                <b-pagination
                  v-if="tri !== 'analyseRadio'"
                  :total-rows="totalItems"
                  :per-page="perPage"
                  v-model="currentPage"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <SyntheseComponent v-if="radioSynthese"> </SyntheseComponent>
      </div>

      <!-- Modal -->
      <b-modal
        ref="modalDetail"
        scrollable
        :title="modalTitle"
        @hidden="modalHidden"
        size="xl"
      >
        <h6 v-if="echantillonDiplayResult">
          Echantillon N° {{ idEchantillon }}
        </h6>
        <div>
          <b-table
            striped
            hover
            :items="modalResults"
            :fields="modalFieldsFor"
            :busy="modalIsBusySpinner"
            outlined
            :class="`font_size_0_7 ${idEchantillon === null ? 'tr-click' : ''}`"
            show-empty
            emptyText="Il n'y a aucun résultat"
            v-on:row-clicked="modalShowOneEchantillon"
          >
            <div slot="table-busy" class="text-center">
              <b-spinner class="align-middle color_green_labco" type="grow" />
            </div>
            <template #cell(COMMENTAIRES)="data">
              <ul v-if="data.item.COMMENTAIRES.length > 0">
                <li v-for="com in data.item.COMMENTAIRES" :key="com">
                  {{ com }}
                </li>
              </ul>
            </template>
          </b-table>
          <ul v-if="modalComments != null && tri == 'echantillonsRadio'">
            <li v-for="com in modalComments" :key="com.CECH_LIG">
              {{ com.CECH_LIG }}
            </li>
          </ul>
        </div>
        <div slot="modal-footer" class="w-100 text-right">
          <b-button v-if="modalBtnPrec" @click="modalPrec" class="float-left">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            Précédent
          </b-button>

          <b-button class="mb-4" @click="modalExportData"
            >Exporter les données</b-button
          >
          <b-button class="mb-4" variant="success" @click="modalHide"
            >OK</b-button
          >
        </div>
      </b-modal>
    </div>
  </b-container>
</template>


<script>
import moment from 'moment'
import api from './../api.js'
import HeaderSearch from './HeaderSearchComponent'
import SyntheseComponent from '@/components/SyntheseComponent'

export default {
  name: 'ResultatsComponent',
  components: {
    HeaderSearch,
    SyntheseComponent
  },
  data () {
    return {
      msg: '',
      isBusy: true,
      results: null,
      numClient: '',
      echantillonFilter: null,
      nbreJour: 30,
      selected: 'dateDbtFin',
      tri: 'resultatsRadio',
      radioSynthese: false,
      value: null,
      jourDisabled: false,
      echantillonDisable: true,
      dateDisable: false,
      dateDebut: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      dateFin: moment().format('YYYY-MM-DD'),
      dateMax: moment().format('YYYY-MM-DD'),
      fields: [],
      echantillon: [],
      idEchantillon: null,
      idAnalyse: null,
      idProduct: null,
      disableRadio: false,
      disablePagination: false,
      echantillonDiplayResult: false,
      perPage: 50,
      currentPage: 1,
      totalItems: 0,
      modalTitle: '',
      modalIsBusySpinner: false,
      modalResults: null,
      modalComments: [],
      modalFieldsFor: [],
      modalBtnPrec: false,
      xhrGet: null
    }
  },
  computed: {
    dateDbt: function () {
      if (this.dateDebut === '') {
        return moment().subtract(this.nbreJour, 'days').format('YYYY-MM-DD')
      } else {
        return this.dateDebut
      }
    }
  },
  mounted () {
    this.displayByResults()
  },
  methods: {
    getAllResultsByDate () {
      const vm = this
      vm.isBusy = true

      if (vm.xhrGet) {
        vm.xhrGet.abort()
      }

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      vm.xhrGet = api.getAllResultatsByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter, vm.currentPage, vm.perPage)
        .done(function (data) {
          vm.results = data.resultats
          vm.totalItems = data.total
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
          vm.results = []
          vm.totalItems = 0
        })
        .always(function () {
          vm.isBusy = false
          vm.xhrGet = null
        })
    },
    getResultsByOneEchantillon (idEchantillon) {
      this.modalIsBusySpinner = true
      const vm = this

      if (vm.xhrGet) {
        vm.xhrGet.abort()
      }

      vm.xhrGet = api.getResultsByOneEchantillon(idEchantillon)
        .done(function (data) {
          vm.modalResults = data.resultats
          vm.modalComments = data.commentaires
          vm.modalTitle = data.resultats[0].LIBELLE
          vm.modalIsBusySpinner = false
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
        .always(function (xhr) {
          vm.xhrGet = null
        })
    },
    getAllEchantillons () {
      const vm = this
      vm.isBusy = true

      if (vm.xhrGet) {
        vm.xhrGet.abort()
      }

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null
      let productFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      if (vm.productFilter !== null) {
        productFilter = vm.productFilter
      }

      vm.xhrGet = api.getAllEchantillonsByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter, productFilter, vm.currentPage, vm.perPage)
        .done(function (data) {
          vm.totalItems = data.total
          vm.results = data.echantillons
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
          vm.results = []
          vm.totalItems = 0
        })
        .always(function () {
          vm.isBusy = false
          vm.xhrGet = null
        })
    },
    getAnalyseByDate () {
      const vm = this
      vm.isBusy = true

      if (vm.xhrGet) {
        vm.xhrGet.abort()
      }

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      vm.xhrGet = api.getAnalyseByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter)
        .done(function (data) {
          vm.results = data.analyses
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
          vm.results = []
        })
        .always(function () {
          vm.isBusy = false
          vm.xhrGet = null
        })
    },
    getProductByDate () {
      const vm = this
      vm.isBusy = true

      if (vm.xhrGet) {
        vm.xhrGet.abort()
      }

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      vm.xhrGet = api.getProductByDate(vm.$root.user.login, dateDbt, dateFin, echantillonFilter)
        .done(function (data) {
          vm.results = data.products
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
          vm.results = []
        })
        .always(function () {
          vm.isBusy = false
          vm.xhrGet = null
        })
    },
    getEchantillonsByAnalyseAndDate (idAnalyse) {
      this.modalIsBusySpinner = true
      const vm = this

      if (vm.xhrGet) {
        vm.xhrGet.abort()
      }

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      vm.xhrGet = api.getEchantillonsByAnalyseAndDate(this.$root.user.login, idAnalyse, dateDbt, dateFin, echantillonFilter)
        .done(function (data) {
          vm.modalResults = data.echantillons
          vm.modalTitle = data.echantillons[0].ANALYSE
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
        .always(function () {
          vm.modalIsBusySpinner = false
          vm.xhrGet = null
        })
    },
    getEchantillonsByProductAndDate (productFilter) {
      this.modalIsBusySpinner = true
      const vm = this

      if (vm.xhrGet) {
        vm.xhrGet.abort()
      }

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      vm.xhrGet = api.getAllEchantillonsByDate(this.$root.user.login, dateDbt, dateFin, echantillonFilter, productFilter, 1, 999)
        .done(function (data) {
          vm.modalResults = data.echantillons
          vm.modalTitle = data.echantillons[0].PRODUIT
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
        .always(function () {
          vm.modalIsBusySpinner = false
          vm.xhrGet = null
        })
    },
    rowSelected (items) {
      // Si le tri des résulats est par échantillon, on affiche une modal lors de la sélection d'une ligne
      if (this.tri === 'echantillonsRadio') {
        this.displayOneEchantillon(items.ECHANTILLON)
      }

      if (this.tri === 'analyseRadio') {
        this.displayByAnalyseByEchantillon(items.IDANALYSE)
      }

      if (this.tri === 'productRadio') {
        this.displayByProductByEchantillon(items.IDPRODUIT)
      }
    },
    displayByResults () {
      const vm = this

      vm.getAllResultsByDate()
      vm.disableRadio = false
      vm.disablePagination = false
      vm.radioSynthese = false
      vm.fields = [
        {
          key: 'ECHANTILLON',
          label: 'N° Echantillon',
          sortable: true
        },
        {
          key: 'NUM_RAPPORT',
          label: 'N° Rapport',
          sortable: true
        },
        {
          key: 'LIBELLE',
          label: 'Echantillon',
          sortable: true
        },
        {
          key: 'LIBELLE_ANALYSE',
          label: 'Analyse',
          sortable: true
        },
        {
          key: 'DATE_COLLECTE',
          label: 'Date de collecte',
          sortable: true
        },
        {
          key: 'ARRIVE',
          label: 'Date d\'arrivée',
          sortable: true
        },
        {
          key: 'RESULTAT',
          label: 'Résultats',
          sortable: true,
          variant: 'info'
        },
        {
          key: 'LOT',
          label: 'Lot',
          sortable: true
        },
        {
          key: 'LIBELLE_ANOMALIE',
          label: 'Anomalie',
          sortable: false
        }
      ]
    },
    displayByEchantillon () {
      const vm = this

      vm.radioSynthese = false
      vm.getAllEchantillons()
      vm.disableRadio = false
      vm.disablePagination = false
      vm.fields = [
        {
          key: 'ECHANTILLON',
          label: 'N° Echantillon',
          sortable: true
        },
        {
          key: 'NUM_RAPPORT',
          label: 'N° Rapport',
          sortable: true
        },
        {
          key: 'LIBELLE',
          label: 'Libelle',
          sortable: true
        },
        {
          key: 'DATE_COLLECTE',
          label: 'Date de collecte',
          sortable: true
        },
        {
          key: 'ARRIVE',
          label: 'Date d\'arrivée',
          sortable: true
        },
        {
          key: 'RESULTAT',
          label: 'Résultats disponibles',
          sortable: true,
          variant: 'info'
        },
        {
          key: 'LOT',
          label: 'Lot',
          sortable: true
        }
      ]
    },
    displayByAnalyse () {
      const vm = this

      vm.radioSynthese = false
      vm.getAnalyseByDate()
      vm.disablePagination = true
      vm.disableRadio = false
      vm.fields = [
        {
          key: 'ANALYSE',
          label: 'Analyse',
          sortable: true
        },
        {
          key: 'NB_ECH',
          label: `Nombres d'échantillons`,
          sortable: true
        }
      ]
    },
    displayByProduct () {
      const vm = this

      vm.radioSynthese = false
      vm.getProductByDate()
      vm.disablePagination = true
      vm.disableRadio = false
      vm.fields = [
        {
          key: 'PRODUIT',
          label: 'Produit',
          sortable: true
        },
        {
          key: 'NB_ECH',
          label: `Nombres d'échantillons`,
          sortable: true
        }
      ]
    },
    displayByAnalyseByEchantillon (idAnalyse) {
      const vm = this

      vm.idAnalyse = idAnalyse
      vm.modalIsBusySpinner = true
      this.modalBtnPrec = false
      vm.$refs.modalDetail.show()

      vm.radioSynthese = false
      vm.getEchantillonsByAnalyseAndDate(idAnalyse)
      vm.echantillonDiplayResult = false
      vm.modalFieldsFor = [
        {
          key: 'ECHANTILLON',
          label: 'N° Echantillon',
          sortable: true
        },
        {
          key: 'NUM_RAPPORT',
          label: 'N° Rapport',
          sortable: true
        },
        {
          key: 'LIBELLE',
          label: 'Echantillon',
          sortable: true
        },
        {
          key: 'RESULTAT',
          label: 'Résultats',
          sortable: true,
          variant: 'info'
        },
        {
          key: 'DATE_COLLECTE',
          label: 'Date de collecte',
          sortable: true
        },
        {
          key: 'ARRIVE',
          label: 'Date d\'arrivée',
          sortable: true
        },
        {
          key: 'DATE_ANALYSE',
          label: 'Date d\'analyse',
          sortable: true
        },
        {
          key: 'LIBELLE_ANOMALIE',
          label: 'Anomalie',
          sortable: false
        },
        {
          key: 'LOT',
          label: 'Lot',
          sortable: true
        }
      ]
    },
    displayByProductByEchantillon (idProduct) {
      const vm = this

      vm.idProduct = idProduct
      vm.modalIsBusySpinner = true
      vm.modalBtnPrec = false
      vm.$refs.modalDetail.show()
      window.trans = vm

      vm.radioSynthese = false
      vm.getEchantillonsByProductAndDate(idProduct)
      vm.echantillonDiplayResult = false
      vm.modalFieldsFor = [
        {
          key: 'ECHANTILLON',
          label: 'N° Echantillon',
          sortable: true
        },
        {
          key: 'NUM_RAPPORT',
          label: 'N° Rapport',
          sortable: true
        },
        {
          key: 'LIBELLE',
          label: 'Libelle',
          sortable: true
        },
        {
          key: 'DATE_COLLECTE',
          label: 'Date de collecte',
          sortable: true
        },
        {
          key: 'ARRIVE',
          label: 'Date d\'arrivée',
          sortable: true
        },
        {
          key: 'RESULTAT',
          label: 'Résultats disponibles',
          sortable: true,
          variant: 'info'
        },
        {
          key: 'LOT',
          label: 'Lot',
          sortable: true
        }
      ]
    },
    displayOneEchantillon (idEchantillon) {
      this.idEchantillon = idEchantillon
      this.modalIsBusySpinner = true

      this.modalBtnPrec = false
      if (['productRadio', 'analyseRadio'].includes(this.tri)) {
        this.modalBtnPrec = true
      }
      this.$refs.modalDetail.show()

      this.getResultsByOneEchantillon(idEchantillon)
      this.echantillonDiplayResult = true
      this.modalFieldsFor = [
        {
          key: 'ANALYSE',
          label: 'Analyses',
          sortable: true
        },
        {
          key: 'RESULTAT',
          label: 'Résulats',
          sortable: true,
          variant: 'info'
        },
        {
          key: 'LIBELLE_ANOMALIE',
          label: 'Anomalie',
          sortable: false
        },
        {
          key: 'COMMENTAIRES',
          label: 'Commentaires',
          sortable: true
        }
      ]
    },
    displaySynthese () {
      const vm = this

      vm.echantillonDiplayResult = false
      vm.radioSynthese = true
      vm.disablePagination = false
      vm.disableRadio = true
      vm.fields = []
    },
    getResultsForRangeDates () {
      const vm = this

      if (vm.tri === 'resultatsRadio') {
        vm.displayByResults()
      }

      if (vm.tri === 'echantillonsRadio') {
        vm.displayByEchantillon()
      }

      if (vm.tri === 'analyseRadio') {
        vm.displayByAnalyse()
      }

      if (vm.tri === 'productRadio') {
        vm.displayByProduct()
      }
    },
    modalExportData () {
      if (this.tri === 'analyseRadio' && this.idEchantillon === null) {
        this.exportByAnalyse()
      } else {
        this.exportByEchantillon()
      }
    },
    modalShowOneEchantillon (data) {
      if (this.idEchantillon === data.ECHANTILLON) {
        return
      }

      this.displayOneEchantillon(data.ECHANTILLON)
    },
    modalPrec () {
      this.idEchantillon = null
      this.rowSelected({
        IDANALYSE: this.idAnalyse,
        IDPRODUIT: this.idProduct
      })
    },
    modalHide () {
      this.$refs.modalDetail.hide()
    },
    modalHidden () {
      this.idEchantillon = null
      this.idAnalyse = null
      this.idProduct = null
    },
    runExport () {
      if (this.tri === 'resultatsRadio') {
        this.exportByResults()
      }

      if (this.tri === 'echantillonsRadio') {
        this.exportByEchantillon()
      }
    },
    exportByResults () {
      const vm = this
      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      api.getAllResultatsByDate(this.$root.user.login, dateDbt, dateFin, echantillonFilter, 1, 99999, 'csv')
        .done((data) => {
          this.downloadFile(data, 'resultats')
        })
        .fail((xhr) => {
          window.fail(xhr, true)
        })
    },
    exportByEchantillon () {
      const vm = this

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      } else if (this.idEchantillon) {
        echantillonFilter = this.idEchantillon
      }

      api.getAllEchantillonsByDate(this.$root.user.login, dateDbt, dateFin, echantillonFilter, vm.idProduct, 1, 99999, 'csv')
        .done((data) => {
          this.downloadFile(data, 'echantillons')
        })
        .fail((xhr) => {
          window.fail(xhr, true)
        })
    },
    exportByAnalyse () {
      const vm = this

      let dateDbt = null
      let dateFin = null
      let echantillonFilter = null

      if (vm.dateDisable === false) {
        dateDbt = vm.dateDbt
        dateFin = vm.dateFin
      }

      if (vm.echantillonDisable === false) {
        echantillonFilter = vm.echantillonFilter
      }

      api.getEchantillonsByAnalyseAndDate(this.$root.user.login, this.idAnalyse, dateDbt, dateFin, echantillonFilter, 'csv')
        .done((data) => {
          this.downloadFile(data, 'resultatsAnalyses')
        })
        .fail((xhr) => {
          window.fail(xhr, true)
        })
    },
    downloadFile (csv, fileName) {
      var blob = new Blob(['\ufeff', csv])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.csv`)
      document.body.appendChild(link)
      link.click()
    }
  },
  watch: {
    selected: function () {
      if (this.selected === 'echantillon') {
        this.echantillonDisable = false
      } else {
        this.echantillonDisable = true
      }

      if (this.selected === 'dateDbtFin') {
        this.dateDisable = false
      } else {
        this.dateDisable = true
      }
    },
    currentPage: function () {
      this.getResultsForRangeDates()
    }
  }
}
</script>

<style>
h5 {
  color: #24509e;
}

.border_bottom {
  border-bottom: #24509e 1px solid;
}

.button_style {
  background-color: #89c338 !important;
  border-color: #2083bc !important;
}

.button_style:hover {
  background-color: #ffffff !important;
  border-color: #89c338 !important;
  color: #2083bc !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #89c338 !important;
}

.margin_2_rem {
  margin-left: 2rem;
}

.custom-control-inline {
  margin-right: 0;
}

.spinner_div {
  position: fixed;
  top: 50vh;
  left: 50vw;
  z-index: 15;
}

.spinner_lg_size {
  width: 3rem;
  height: 3rem;
}

.color_green_labco {
  color: #89c338;
}

.btn-light:not(:disabled):not(.disabled).active,
.btn-light:not(:disabled):not(.disabled):hover {
  /* color: black !important; */
  background-color: transparent;
  border-color: transparent;
}

.flex {
  display: flex;
  justify-content: center;
}

.btn-resultats {
  background: #509eb3;
  height: 50%;
}

.btn-resultats:active {
  background: #24509e !important;
}

.btn-resultats:hover {
  background: #24509e !important;
}

.rad {
  border-radius: 0px 20px 0px 20px !important;
}

.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #24509e !important;
  border-color: transparent !important;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("../assets/radioactive.png");
}

.custom-radio .custom-control-label::before {
  background-image: url("../assets/radio.png");
}

.custom-control-label::after {
  background-size: cover !important;
}

.custom-control-label::before {
  background-size: cover !important;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ebf0f2 !important;
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: #dce7eb !important;
}

.table td {
  font-weight: bold;
}

.modal-body h6 {
  color: #509eb3;
}
.modal-body h5 {
  color: #157884;
}

.dropdown-menu a.dropdown-item:hover {
  background: #0071bc !important;
}

.tr-click tr {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/ResultatsComponent.vue